/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Paytechno
 */
export class Paytechno {
    /**
     *
     * @type {string}
     * @memberof Paytechno
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Paytechno
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Paytechno
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Paytechno
     */
    merchantID: string;
    /**
     *
     * @type {string}
     * @memberof Paytechno
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Paytechno
     */
    ApiPassword: string;
    /**
     *
     * @type {string}
     * @memberof Paytechno
     */
    ApiUserName: string;
    /**
     *
     * @type {string}
     * @memberof Paytechno
     */
    storeId: string;
    /**
     *
     * @type {string}
     * @memberof Paytechno
     */
    terminalKey: string;
    /**
     *
     * @type {boolean}
     * @memberof Paytechno
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Paytechno
     */
    autoApprove: boolean;
}
